import React, { useState, useEffect } from "react";
import { classNames } from "primereact/utils";
import { isSidebarVisible } from "../services/common/states";
import { useDispatch, useSelector } from 'react-redux';
import { selectUser } from '../services/store/userSlice';
import properties from '../config/environmentProperties';
import { Dialog } from "primereact/dialog";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import pkg from '../../package.json'
const AppFooter = () => {
    const [buildInfoVisible, setBuildInfoVisible] = useState(false);
    const [menuVisible, setMenuVisible] = useState(true);
    const [showDetail, setShowDetails] = useState(false);
    const [details, setDetails] = useState([]);
    const user = useSelector(selectUser);
    const [roles, setRoles] = useState([]);

    useEffect(() => {
        isSidebarVisible.subscribe(v => setMenuVisible(v));
    }, []);

    useEffect(() => {
        try {
            let r = JSON.parse(localStorage.getItem('show_roles'));
            // const roleList = r.map((e, index) => { return (<strong key={'fr-' + index} className="footer-roles">{e}</strong>) })
            setRoles(r.join(', '))
        } catch (error) { }
    }, [user]);

    const onBuildInfoClickHandler = () => {
        setShowDetails(true);
        setDetails([
            { title: 'Application Version', value: pkg.version },
            // { title: 'Deployment Build Number', value: pkg.version },
            { title: 'Build By', value: pkg["build-by"] },
            { title: 'Build Time', value: pkg["build-time"] },
            { title: 'Wrapper Build', value: pkg["wrapper"] },
            { title: 'GIT Commit', value: pkg['commit'] },
            { title: 'Frontend Framework Version', value: pkg['erf'] },
            { title: 'Backend Framework Version', value: pkg['enf'] },
            { title: 'ESS API Version', value: pkg["ess-api"] },
            { title: 'User Roles', value: roles },
        ]);
    }

    const detailDialog = () => {
        return (<>
            <Dialog header='Application Info' style={{ width: '700px' }} visible={showDetail} onHide={() => setShowDetails(false)}>
                <div className="grid mt-3" style={{overflow: "hidden"}}>
                    <div className="col">
                        <DataTable value={details} stripedRows responsiveLayout="scroll" className='hide-title'>
                            <Column field="title" header="Title" style={{ width: '300px' }} body={(r => <strong>{r.title}</strong>)}></Column>
                            <Column field="value" header="Value"></Column>
                        </DataTable>
                    </div>
                </div>
            </Dialog>
        </>)
    }

    return <div className={classNames(menuVisible ? 'layout-footer' : 'layout-footer-wm')}>
        <div className="clearfix" style={{ width: 'calc(100vw - 180px)' }}>
            <div className="grid">
                <div className="col">
                    <div className="pt-2">
                        <span onClick={onBuildInfoClickHandler} className="footer-text-left link">Espire Self Service Portal {pkg.version}</span>
                        <span style={{ color: '#344a7b' }}> :   {properties.currentEnvironment.depType.toUpperCase()} </span>
                    </div>
                </div>
                <div className="col">
                    {/* <div className="pt-2 rights" style={{ textAlign: 'right' }}>@2022, Espire Infolab Pvt, Ltd. All Rights Reserved</div> */}
                    <div className="pt-2 rights" style={{ textAlign: 'right' }}>Espire Infolab Pvt. Ltd.</div>
                </div>
                {/* <div className="col" style={{ textAlign: 'right' }}>
                    <div className="pt-2">
                        <span className="footer-text-left">Roles : </span>
                        {roles}
                    </div>
                </div> */}
            </div>
        </div>
        {detailDialog()}
    </div>
}

export default AppFooter;